import { Component, OnInit, ViewChild } from "@angular/core";
import { Brands } from "app/_models/brands";
import { CrudBrandService } from "app/_services/MasterCrudOps/crud-brand.service";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import { LiveAnnouncer } from "@angular/cdk/a11y";
import { EditBrandComponent } from "./edit-brand/edit-brand.component";
import { AddBrandComponent } from "./add-brand/add-brand.component";
import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";
import { UserModel } from "app/_models/user-model";
declare const swal: any;

@Component({
  selector: "app-brand",
  templateUrl: "./brand.component.html"
})
export class BrandComponent implements OnInit {
  currentUser: UserModel;
  brands: Brands[];
  totalresultDetails: Brands[];
  isAdminGroupUser: boolean = false;
  displayedColumns: string[] = [
    "icon",
    "brandName",
    "description",
    "edit",
    "delete",
  ];
  dataSource = new MatTableDataSource<Brands>([]);
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) set sort(value: MatSort) {
    if (this.dataSource != null) {
      this.dataSource.sort = value;
    }
  }
  isLoaderResult = true;
  resultLength = 0;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [25, 50, 75, 100];
  editBrand: Brands;
  pageEvent = PageEvent;

  constructor(
    public datepipe: DatePipe,
    private readonly _liveAnnouncer: LiveAnnouncer,
    private readonly matDialog: MatDialog,
    private readonly crudBrandService: CrudBrandService,
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  ngOnInit(): void {
    this.isLoaderResult = true;
    this.dataSource = null; 
    this.brands = null;
    this.pageSize  = 25;
    this.getAllBrands(1, this.pageSize, false);
    this.isLoaderResult = false;
  }
  ngAfterViewInit() {
    if (this.dataSource != null) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  announceBrandSort(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  onAddBrandClick() {
    const dialogRef = this.matDialog.open(AddBrandComponent, {
      width: "800px",
      disableClose: false,
      data: {pageNumber:(this.paginator.pageIndex +1 ),  pageSize:this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status )
      {
        this.getAllBrands(result.pageNumber, result.pageSize,false);
        setTimeout(() => {
        }, 1500);
      }
    });
  }

  onEditBrand(e, element): void {
    this.editBrand = JSON.parse(JSON.stringify(element));
    const dialogRef = this.matDialog.open(EditBrandComponent, {
      width: "800px",
      disableClose: true,
      data: {  brand:this.editBrand,   pageNumber:(this.paginator.pageIndex +1 ),  pageSize:this.paginator.pageSize}
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAllBrands(result.pageNumber, result.pageSize,false);
        setTimeout(() => {
        }, 1500);
      }
    });
    
  }
  

  onDeleteBrand(e, element) {
    swal({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Delete IT!",
    }).then((result) => {
      if (result === true) {
        this.deleteBrand(e, element);
      }
    });
  }

  deleteBrand(e, element): void {
    this.isLoaderResult = true;
    this.crudBrandService.deleteBrand(element.brandId).subscribe((data) => {
      if (data.didError) {
        swal({
          title: "",
          text: data.message + "\n" + data.additionalMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      } else {
        swal({
          title: "",
          text: data.message,
          type: "success",
          confirmButtonClass: "btn btn-info",
        });
        this.getAllBrands((this.paginator.pageIndex+1), this.paginator.pageSize, false);
      }
    });
    this.isLoaderResult = false;
  }

  getAllBrands(pageNumber: number, currPageSize: number, hasDownloadAllData:boolean) {
    let model = {
      currentPage: pageNumber,
      pageSize: currPageSize,
      downloadAllData: hasDownloadAllData,
      stateId:0
    } ;
    this.crudBrandService.getPagedActiveBrands(model)
    .subscribe((data) => {
      this.isLoaderResult = false;
      if (!data.didError) {
        this.brands = data.model;
        this.dataSource = new MatTableDataSource<Brands>(
          this.brands
        );
        this.totalRows = data.totalRecords;
        this.resultLength = this.brands.length;
      } else {
        this.brands = data.model;
        swal({
          title: "",
          text: data.message,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    },
    (error) => {
      this.isLoaderResult = false;
      swal({
        title: "",
        text: "Somthing went wrong. Please contact admin",
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
    }
  );
  }

  exportExcel() {
    const workSheet = XLSX.utils.json_to_sheet(
      this.dataSource.data.map((item) => {
        return { Brand: item.brandName, Description: item.description };
      })
    );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
    let fileName =
      "Brands_" +
      this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
      ".xlsx";
    XLSX.writeFile(workBook, fileName);
  }

  onDownloadAllClick()
  {
    swal({
      title: "Are you sure to do this?",
      text: "This process does not display data. It will download all records in a spreadsheet.",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Download the records.",
    }).then((result) => {
      if (result === true) {
        this.isLoaderResult = true;
        let model = {
          currentPage:0,
          pageSize:0,
          downloadAllData:true,
          stateId: 0
        };
       this.crudBrandService.getPagedActiveBrands(model)
           .subscribe(
                    (results) => {
          this.isLoaderResult = false;
          if (!results.didError) {
            this.totalresultDetails = results.model;
            const workSheet = XLSX.utils.json_to_sheet(
              this.totalresultDetails.map((item) => {
                return {
                  Brand: item.brandName, 
                  Description: item.description 
                };
              })
            );
            const workBook: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
            let fileName =
              "Brands_" +
              this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
              ".xlsx";
            XLSX.writeFile(workBook, fileName);
          } else {
            this.isLoaderResult = false;
            swal({
              title: "",
              text: results.message,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          }
        },
        (error) => {
          this.isLoaderResult = false;
          swal({
            title: "",
            text: "Somthing went wrong. Please contact admin",
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      );
      }
    });
  }

 applyBrandFilter(filterValue: string) {
       this.dataSource.filter = filterValue;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getAllBrands((this.paginator.pageIndex+1), this.paginator.pageSize, false);
  }
}
